/**
 * Textos de `credits` en español: las evaluaciones de inglés prepagadas de las
 * agencias (saldo, compra en Stripe, movimientos) y su vista de operación.
 *
 * Voz de TBit: tutea, palabras simples, sin raya larga, nunca «automatizar».
 */
const plural = (n: number, one: string, many: string) => (n === 1 ? one : many);

const credits = {
  nav: 'Evaluaciones',

  /** El chip del saldo (tarjeta del candidato y encabezado de la página). */
  chip: {
    left: (n: number) => (n === 1 ? 'Te queda 1 evaluación' : `Te quedan ${n} evaluaciones`),
    none: 'No te quedan evaluaciones',
    freeStart: (n: number) => `${n} gratis para empezar`,
    reserved: (n: number) => plural(n, '1 en curso', `${n} en curso`),
  },
  buy: 'Comprar evaluaciones',

  page: {
    scope: 'Evaluaciones de inglés',
    title: 'Tus evaluaciones de inglés',
    lede: 'Cada evaluación es una llamada de unos 10 minutos con una entrevistadora de IA y un informe con el nivel. Solo se descuenta si recibes un nivel.',
    balance: 'Disponibles',
    reserved: 'En curso',
    reservedNote: 'Pedidas y esperando la llamada. Si vencen o las cancelas, vuelven a tu saldo.',
    freeNote: (n: number) => `Empezaste con ${n} gratis.`,
    rules:
      'Pedir una evaluación aparta 1. Si el candidato no llama a tiempo, la cancelas o la llamada no alcanza para dar un nivel, vuelve a tu saldo. Si la persona ya tiene un resultado reciente, lo recibes al instante y cuenta como 1.',
    packsTitle: 'Comprar más',
    pack: (n: number) => `${n} evaluaciones`,
    perUnit: (price: string) => `${price} cada una`,
    payNote: 'Pagas una sola vez con tarjeta en Stripe. Te llega la factura por correo. No es una suscripción.',
    buyPack: 'Comprar',
    opening: 'Abriendo el pago',
    buyFailed: 'No pudimos abrir el pago. Intenta de nuevo en un minuto.',
    returnWaiting: 'Recibimos tu pago. Estamos sumando las evaluaciones a tu saldo.',
    returnDone: (n: number) => `Listo: sumamos ${n} evaluaciones a tu saldo.`,
    returnSlow:
      'Tu pago está hecho, pero las evaluaciones todavía no aparecen. Recarga en unos minutos y, si siguen sin aparecer, escríbenos a soporte.',
    returnCanceled: 'Cancelaste el pago. No se hizo ningún cobro.',
    historyTitle: 'Movimientos',
    historyEmpty: 'Todavía no hay movimientos.',
    types: {
      grant_free: 'Gratis para empezar',
      purchase: 'Compra',
      reserve: 'Evaluación pedida',
      consume: 'Evaluación cobrada',
      release: 'Devuelta a tu saldo',
      adjust: 'Ajuste de TBit',
      refund: 'Devolución',
    } as Record<string, string>,
    columns: { date: 'Fecha', movement: 'Movimiento', amount: 'Evaluaciones' },
    paid: (price: string) => `Pagaste ${price}`,
    disabled: 'Por ahora las evaluaciones de inglés no se descuentan de un saldo.',
    loadError: 'No pudimos cargar tu saldo. Recarga la página.',
    back: 'Volver a candidatos',
  },

  /** En la tarjeta del candidato, al pedir la evaluación. */
  panel: {
    costNote: 'Usa 1 de tus evaluaciones. Si no hay nivel, vuelve a tu saldo.',
    noCredits: 'No te quedan evaluaciones. Compra un paquete para pedir esta.',
  },

  /** La consola de operación (/admin → Agencias). */
  admin: {
    column: 'Evaluaciones',
    open: 'Créditos',
    title: (agency: string) => `Créditos de ${agency}`,
    balance: 'Saldo',
    ledgerSum: 'Suma del libro',
    outOfSync: 'El saldo no cuadra con el libro. Avisa a ingeniería antes de ajustar.',
    reserved: 'Reservas abiertas',
    adjustTitle: 'Ajuste manual',
    adjustCredits: 'Evaluaciones (+ o -)',
    adjustNote: 'Nota (obligatoria): por qué',
    adjustSave: 'Guardar ajuste',
    adjustInvalid: 'Escribe un número entero distinto de cero y una nota.',
    adjustFailed: (msg: string) => `No se pudo ajustar: ${msg}`,
    entries: 'Asientos',
    pending: 'sin aplicar',
    close: 'Cerrar',
    loadError: 'No se pudieron cargar los créditos.',
    revenue: 'Evaluaciones de inglés vendidas',
    revenueNote: (packs: number, credits: number) => `${packs} ${packs === 1 ? 'paquete' : 'paquetes'} · ${credits} evaluaciones`,
  },
};

export default credits;
